"use client";

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@repo/design-system/components/ui/skeleton";
import dynamic from "next/dynamic";
import { env } from "~/setup/env";
import { useLanguage } from "~/translations/loader/use-language";
import { Searchbar } from "../../filterbar/searchbar-eon";
const WatchJobs = dynamic(() => import("../../filterbar/watch-jobs-eon").then(m => m.WatchJobs), {
  ssr: false,
  loading: () => <Skeleton className="h-12" />
});
export default function FilterbarEonSverige() {
  const $ = _c(9);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      backgroundImage: `url(${env.NEXT_PUBLIC_ASSET_URL}images/jobboard/filterbar_pattern.png)`,
      backgroundSize: "cover",
      backgroundPosition: "center"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.sverige_filterbar_hl) {
    t1 = <div className="grid grid-flow-row md:grid-flow-col"><h1 className="font-bold text-5xl md:mb-2">{t.sverige_filterbar_hl}</h1></div>;
    $[1] = t.sverige_filterbar_hl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t.aria_header_filterbar) {
    t2 = <h2 className="sr-only">{t.aria_header_filterbar}</h2>;
    $[3] = t.aria_header_filterbar;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="grid grid-flow-row items-center gap-x-4 gap-y-4 md:grid-cols-2 [&_button_div:first-child]:hidden"><Searchbar /><WatchJobs buttonVariant="outline" /></div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2) {
    t4 = <section className="outer-container grid justify-items-center py-container text-primary-foreground" id="filterbar" style={t0} tabIndex={-1}><div className="inner-container grid gap-y-4">{t1}{t2}{t3}</div></section>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}